import script from "./AddPotentialPolicyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPotentialPolicyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPotentialPolicyModal.vue?vue&type=style&index=0&id=7d866c43&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d866c43"]])

export default __exports__